export default {
  // 风险评估类型
  riskRatingTypes: [
    {
      title: "Low",
      value: 1,
    },
    {
      title: "Medium",
      value: 2,
    },
    {
      title: "High",
      value: 3,
    },
  ],
  // 申请状态
  applymentStatusList: [
    {
      //待提交
      title: "Draft",
      value: "DRAFT",
    },
    {
      // 咨询中
      title: "Inquiring",
      value: "INQUIRING",
    },
    {
      // 报价中
      title: "Quoting",
      value: "QUOTING",
    },
    {
      // 报价已提交（待审核）
      title: "Quoting reviewing",
      value: "QUOTATION_AUDITING",
    },
    {
      // 报价完成
      title: "Quotation proposed",
      value: "QUOTATION_AUDIT_PASS",
    },
    {
      // 报价审批失败
      title: "Quotation rejected",
      value: "QUOTATION_AUDIT_FAIL",
    },
    {
      //已提交
      title: "Submitted",
      value: "SUBMITTED",
    },
    {
      //初筛中（一级审核）
      title: "Checking",
      value: "CHECKING",
    },
    {
      //初筛不合格（一级审核）
      title: "Checking Failed",
      value: "ILLEGAL",
    },
    {
      //驳回（资料填写不完整）（业务）
      title: "Rejected",
      value: "REJECTED",
    },
    {
      //已修正（资料重填）（用户）
      title: "Corrected",
      value: "CORRECTED",
    },
    {
      //修订中（业务）
      title: "Revising",
      value: "REVISING",
    },
    {
      //已修订完成（业务）
      title: "Revise Completed",
      value: "REVISE_FINISH",
    },
    {
      //复核中（复核）
      title: "Reviewing",
      value: "AUDITING",
    },
    {
      //复核失败（复核）
      title: "Review Failed",
      value: "AUDIT_FAIL",
    },
    {
      //复核成功（复核）
      title: "Review Passed",
      value: "AUDIT_SUCCESS",
    },
    {
      //申请退款中（业务）
      title: "Refund Applied",
      value: "REFUND_APPLYING",
    },
    {
      //申请退款拒绝（一级审核）
      title: "Refund Checking Rejected",
      value: "REFUND_APPLY_DENY",
    },
    {
      //申请退款已确认（一级审核）
      title: "Refund Checking Passed",
      value: "REFUND_APPLY_AGREED",
    },
    {
      //申请退款驳回（复核）
      title: "Refund Review Rejected",
      value: "REFUND_APPLY_REJECT",
    },
    {
      //申请退款通过（复核）
      title: "Refund Review Passed",
      value: "REFUND_APPLY_PASS",
    },
    {
      //退款处理中（若退款单状态为REFUND_INFO_NOT_ENOUGH，则需要补充退款信息）（财务，由业务根据退款状态进行响应）
      title: "Refund Money Processing",
      value: "REFUND_HANDING",
    },
    {
      //已取消（退款成功后申请单取消）
      title: "Refund Completed & Order Canceled",
      value: "CANCELED",
    },
    {
      //更新申请中 (ACRA 和/或 其他)（业务）
      title: "Processing to Gov and/or other",
      value: "ACRA_APPLYING",
    },
    {
      //ACRA 已驳回（业务）
      title: "Rejected by Gov and/or other",
      value: "ACRA_REJECTED",
    },
    {
      //已完成（业务)
      title: "Order Completed",
      value: "FINISH",
    },
    {
      //申请终止交易中（业务）
      title: "Suspend Transaction Applying",
      value: "SUSPEND_TRANSACTION_APPLYING",
    },
    {
      //申请终止交易驳回（复核）
      title: "Suspend Transaction Apply Reject",
      value: "SUSPEND_TRANSACTION_APPLY_REJECT",
    },
    {
      //已终止（退款成功后申请单取消）
      title: "Terminated",
      value: "TERMINATED",
    },
    {
      //已作废
      title: "Forfeited",
      value: "FORFEITED",
    },
  ],
  // 订单状态
  orderStatusList: [
    {
      //待付款
      title: "Unpaid",
      value: "UNPAID",
    },
    {
      //部分付款
      title: "Partially Paid",
      value: "PARTLY_PAID",
    },
    {
      //已完成
      title: "Paid",
      value: "COMPLETE",
    },
    {
      //已关闭
      title: "Closed",
      value: "CLOSED",
    },
    {
      //已作废
      title: "Forfeited",
      value: "FORFEITED",
    },
  ],
  // 退款状态
  refundStatusList: [
    {
      //退款中
      title: "Refunding",
      value: "REFUNDING",
    },
    {
      //退款成功
      title: "Refunded",
      value: "REFUNDED",
    },
    {
      //退款信息无异议，待退款
      title: "Pending Refund",
      value: "REFUND_PENDING",
    },
    {
      //退款失败，退款信息不全，待进一步提供退款资料
      title: "Refund Failed due to Insufficient Info",
      value: "REFUND_INFO_NOT_ENOUGH",
    },
    {
      //退款信息已补充（业务）
      title: "Refund Info Updated",
      value: "REFUND_INFO_UPDATED",
    },
  ],
  // 续约状态
  renewStatusList: [
    // 续约中
    {
      title: "Renewing",
      value: "RENEWING",
    },
    // 已续约
    {
      title: "Renewed",
      value: "RENEWED",
    },
  ],
  // 订单类型
  orderTypeList: [
    {
      // 套餐/自定义套餐
      title: "Ordinary",
      value: "generic",
    },
    {
      // 定制化服务
      title: "Quotation",
      value: "quotation_part",
    },
    {
      // Quotation (V)
      title: "Quotation (V)",
      value: "adjustment",
    },
  ],
  // 支付类型
  payTypes: [
    {
      //支付宝
      title: "Alipay",
      value: "ALIPAY",
    },
    {
      //银行转账
      title: "Bank Transfer",
      value: "BANK_TRANSFER",
    },
  ],
  // 主体类型
  entityTypes: [
    {
      title: "Corporate related",
      value: "COMPANY",
    },
    {
      title: "Fund related",
      value: "FUND",
    },
  ],
  // 全部的业务类型
  businessTypes: [
    {
      title: "Company Incorporation",
      value: "COMPANY_INCORPORATION",
    },
    {
      title: "Corporate Service Transfer – Company Secretarial related services",
      value: "SERVICE_TRANSFER",
    },
    {
      title: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
      value: "COMPREHENSIVE_CUSTOMIZED",
    },
    {
      title: "Fund Admin Services – Customized (Exclusive of Incorporation)",
      value: "FUND_ADMIN_CUSTOMIZED",
    },
  ],
  // 国家和支持的语言、业务类型
  countryList: [
    {
      title: "Singapore",
      value: "Singapore",
      native: true,
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
      supportBusinessTypesList: [
        {
          title: "Company Incorporation",
          value: "COMPANY_INCORPORATION",
        },
        {
          title: "Corporate Service Transfer – Company Secretarial related services",
          value: "SERVICE_TRANSFER",
        },
        {
          title: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
          value: "COMPREHENSIVE_CUSTOMIZED",
        },
        {
          title: "Fund Admin Services – Customized (Exclusive of Incorporation)",
          value: "FUND_ADMIN_CUSTOMIZED",
        },
      ],
    },
    {
      title: "Malaysia",
      value: "Malaysia",
      native: true,
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
        {
          title: "English + Bahasa Malaysia",
          value: "en+ms",
        },
      ],
      supportBusinessTypesList: [
        {
          title: "Company Incorporation",
          value: "COMPANY_INCORPORATION",
        },
        {
          title: "Corporate Service Transfer – Company Secretarial related services",
          value: "SERVICE_TRANSFER",
        },
        {
          title: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
          value: "COMPREHENSIVE_CUSTOMIZED",
        },
      ],
    },
    {
      title: "Virgin Islands, British",
      value: "Virgin Islands, British",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
      supportBusinessTypesList: [
        {
          title: "Company Incorporation",
          value: "COMPANY_INCORPORATION",
        },
        {
          title: "Corporate Service Transfer – Company Secretarial related services",
          value: "SERVICE_TRANSFER",
        },
        {
          title: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
          value: "COMPREHENSIVE_CUSTOMIZED",
        },
      ],
    },
    {
      title: "Cayman Islands",
      value: "Cayman Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
      supportBusinessTypesList: [
        {
          title: "Company Incorporation",
          value: "COMPANY_INCORPORATION",
        },
        {
          title: "Corporate Service Transfer – Company Secretarial related services",
          value: "SERVICE_TRANSFER",
        },
        {
          title: "Comprehensive Corporate Services – Customized (Exclusive of Incorporation)",
          value: "COMPREHENSIVE_CUSTOMIZED",
        },
      ],
    },
    {
      title: "Thailand",
      value: "Thailand",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
        {
          title: "English + ภาษาไทย",
          value: "en+th",
        },
      ],
    },
    {
      title: "Indonesia",
      value: "Indonesia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
        {
          title: "English + Bahasa Indonesia",
          value: "en+id",
        },
      ],
    },
    {
      title: "Philippines",
      value: "Philippines",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
        {
          title: "English + Filipino",
          value: "en+fil",
        },
      ],
    },
    {
      title: "Australia",
      value: "Australia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "China",
      value: "China",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Hong Kong",
      value: "Hong Kong",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Afghanistan",
      value: "Afghanistan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Albania",
      value: "Albania",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Algeria",
      value: "Algeria",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "American Samoa",
      value: "American Samoa",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Andorra",
      value: "Andorra",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Angola",
      value: "Angola",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Anguilla",
      value: "Anguilla",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Antarctica",
      value: "Antarctica",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Antigua and Barbuda",
      value: "Antigua and Barbuda",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Argentina",
      value: "Argentina",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Armenia",
      value: "Armenia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Aruba",
      value: "Aruba",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Austria",
      value: "Austria",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Azerbaijan",
      value: "Azerbaijan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bahamas",
      value: "Bahamas",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bahrain",
      value: "Bahrain",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bangladesh",
      value: "Bangladesh",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Barbados",
      value: "Barbados",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Belarus",
      value: "Belarus",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Belgium",
      value: "Belgium",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Belize",
      value: "Belize",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Benin",
      value: "Benin",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bermuda",
      value: "Bermuda",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bhutan",
      value: "Bhutan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bolivia",
      value: "Bolivia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bonaire Sint Eustatius And Saba",
      value: "Bonaire Sint Eustatius And Saba",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bosnia and Herzegovina",
      value: "Bosnia and Herzegovina",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Botswana",
      value: "Botswana",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bouvet Island",
      value: "Bouvet Island",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Brazil",
      value: "Brazil",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "British Indian Ocean Territory",
      value: "British Indian Ocean Territory",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Brunei Darussalam",
      value: "Brunei Darussalam",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Bulgaria",
      value: "Bulgaria",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Burkina Faso",
      value: "Burkina Faso",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Burundi",
      value: "Burundi",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cabo Verde",
      value: "Cabo Verde",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cambodia",
      value: "Cambodia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cameroon",
      value: "Cameroon",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Canada",
      value: "Canada",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },

    {
      title: "Central African Republic",
      value: "Central African Republic",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Chad",
      value: "Chad",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Chile",
      value: "Chile",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Christmas Island",
      value: "Christmas Island",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cocos (Keeling) Islands",
      value: "Cocos (Keeling) Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Colombia",
      value: "Colombia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Comoros",
      value: "Comoros",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Congo",
      value: "Congo",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Congo, The Democratic Republic of The",
      value: "Congo, The Democratic Republic of The",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cook Islands",
      value: "Cook Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Costa Rica",
      value: "Costa Rica",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cote D'Ivoire",
      value: "Cote D'Ivoire",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Croatia",
      value: "Croatia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cuba",
      value: "Cuba",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Curacao",
      value: "Curacao",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Cyprus",
      value: "Cyprus",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Czechia",
      value: "Czechia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Denmark",
      value: "Denmark",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Djibouti",
      value: "Djibouti",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Dominica",
      value: "Dominica",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Dominican Republic",
      value: "Dominican Republic",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Ecuador",
      value: "Ecuador",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Egypt",
      value: "Egypt",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "El Salvador",
      value: "El Salvador",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Equatorial Guinea",
      value: "Equatorial Guinea",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Eritrea",
      value: "Eritrea",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Estonia",
      value: "Estonia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Eswatini",
      value: "Eswatini",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Ethiopia",
      value: "Ethiopia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Falkland Islands (Malvinas)",
      value: "Falkland Islands (Malvinas)",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Faroe Islands",
      value: "Faroe Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Fiji",
      value: "Fiji",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Finland",
      value: "Finland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "France",
      value: "France",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "French Guiana",
      value: "French Guiana",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "French Polynesia",
      value: "French Polynesia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "French Southern Territories",
      value: "French Southern Territories",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Gabon",
      value: "Gabon",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Gambia",
      value: "Gambia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Georgia",
      value: "Georgia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Germany",
      value: "Germany",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Ghana",
      value: "Ghana",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Gibraltar",
      value: "Gibraltar",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Greece",
      value: "Greece",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Greenland",
      value: "Greenland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Grenada",
      value: "Grenada",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guadeloupe",
      value: "Guadeloupe",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guam",
      value: "Guam",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guatemala",
      value: "Guatemala",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guernsey",
      value: "Guernsey",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guinea",
      value: "Guinea",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guinea-Bissau",
      value: "Guinea-Bissau",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Guyana",
      value: "Guyana",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Haiti",
      value: "Haiti",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Heard Island And Mcdonald Islands",
      value: "Heard Island And Mcdonald Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Holy See",
      value: "Holy See",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Honduras",
      value: "Honduras",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Hungary",
      value: "Hungary",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Iceland",
      value: "Iceland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "India",
      value: "India",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Iran, Islamic Republic of",
      value: "Iran, Islamic Republic of",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Iraq",
      value: "Iraq",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Ireland",
      value: "Ireland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Isle of Man",
      value: "Isle of Man",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Israel",
      value: "Israel",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Italy",
      value: "Italy",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Jamaica",
      value: "Jamaica",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Japan",
      value: "Japan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Jordan",
      value: "Jordan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Kazakhstan",
      value: "Kazakhstan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Kenya",
      value: "Kenya",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Kiribati",
      value: "Kiribati",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Korea, Democratic People's Republic of",
      value: "Korea, Democratic People's Republic of",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Korea, Republic of",
      value: "Korea, Republic of",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Kuwait",
      value: "Kuwait",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Kyrgyzstan",
      value: "Kyrgyzstan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Lao People's Democratic Republic",
      value: "Lao People's Democratic Republic",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Latvia",
      value: "Latvia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Lebanon",
      value: "Lebanon",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Lesotho",
      value: "Lesotho",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Liberia",
      value: "Liberia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Libya",
      value: "Libya",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Liechtenstein",
      value: "Liechtenstein",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Lithuania",
      value: "Lithuania",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Luxembourg",
      value: "Luxembourg",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Macao",
      value: "Macao",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Madagascar",
      value: "Madagascar",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Malawi",
      value: "Malawi",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Maldives",
      value: "Maldives",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mali",
      value: "Mali",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Malta",
      value: "Malta",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Marshall Islands",
      value: "Marshall Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Martinique",
      value: "Martinique",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mauritania",
      value: "Mauritania",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mauritius",
      value: "Mauritius",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mayotte",
      value: "Mayotte",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mexico",
      value: "Mexico",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Micronesia",
      value: "Micronesia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Moldova",
      value: "Moldova",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Monaco",
      value: "Monaco",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mongolia",
      value: "Mongolia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Montenegro",
      value: "Montenegro",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Montserrat",
      value: "Montserrat",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Morocco",
      value: "Morocco",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Mozambique",
      value: "Mozambique",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Myanmar",
      value: "Myanmar",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Namibia",
      value: "Namibia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Nauru",
      value: "Nauru",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Nepal",
      value: "Nepal",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Netherlands",
      value: "Netherlands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "New Caledonia",
      value: "New Caledonia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "New Zealand",
      value: "New Zealand",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Nicaragua",
      value: "Nicaragua",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Niger",
      value: "Niger",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Nigeria",
      value: "Nigeria",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Niue",
      value: "Niue",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Norfolk Island",
      value: "Norfolk Island",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "North Macedonia",
      value: "North Macedonia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Northern Mariana Islands",
      value: "Northern Mariana Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Norway",
      value: "Norway",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Oman",
      value: "Oman",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Pakistan",
      value: "Pakistan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Palau",
      value: "Palau",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Palestine State",
      value: "Palestine State",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Panama",
      value: "Panama",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Papua New Guinea",
      value: "Papua New Guinea",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Paraguay",
      value: "Paraguay",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Peru",
      value: "Peru",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Pitcairn",
      value: "Pitcairn",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Poland",
      value: "Poland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Portugal",
      value: "Portugal",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Puerto Rico",
      value: "Puerto Rico",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Qatar",
      value: "Qatar",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Reunion",
      value: "Reunion",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Romania",
      value: "Romania",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Russian Federation",
      value: "Russian Federation",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Rwanda",
      value: "Rwanda",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Barthelemy",
      value: "Saint Barthelemy",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Helena Ascension and Tristan Da Cunha",
      value: "Saint Helena Ascension and Tristan Da Cunha",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Kitts and Nevis",
      value: "Saint Kitts and Nevis",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Lucia",
      value: "Saint Lucia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Marino (French Part)",
      value: "Saint Marino (French Part)",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Pierre and Miquelon",
      value: "Saint Pierre and Miquelon",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saint Vincent and the Grenadines",
      value: "Saint Vincent and the Grenadines",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Samoa",
      value: "Samoa",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "San Marino",
      value: "San Marino",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sao Tome and Principe",
      value: "Sao Tome and Principe",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Saudi Arabia",
      value: "Saudi Arabia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Senegal",
      value: "Senegal",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Serbia",
      value: "Serbia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Seychelles",
      value: "Seychelles",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sierra Leone",
      value: "Sierra Leone",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sint Maarten (Dutch Part)",
      value: "Sint Maarten (Dutch Part)",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Slovakia",
      value: "Slovakia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Slovenia",
      value: "Slovenia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Solomon Islands",
      value: "Solomon Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Somalia",
      value: "Somalia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "South Africa",
      value: "South Africa",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "South Korea",
      value: "South Korea",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "South Georgia and The Souch Sandwich Islands",
      value: "South Georgia and The Souch Sandwich Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "South Sudan",
      value: "South Sudan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Spain",
      value: "Spain",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sri Lanka",
      value: "Sri Lanka",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sudan",
      value: "Sudan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Suriname",
      value: "Suriname",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Svalbard and Jan Mayen",
      value: "Svalbard and Jan Mayen",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Sweden",
      value: "Sweden",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Switzerland",
      value: "Switzerland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Syrian Arab Republic",
      value: "Syrian Arab Republic",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Taiwan",
      value: "Taiwan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tajikistan",
      value: "Tajikistan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tanzania, United Republic of",
      value: "Tanzania, United Republic of",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Timor-Leste",
      value: "Timor-Leste",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Togo",
      value: "Togo",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tokelau",
      value: "Tokelau",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tonga",
      value: "Tonga",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Trinidad and Tobago",
      value: "Trinidad and Tobago",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tunisia",
      value: "Tunisia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Turkey",
      value: "Turkey",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Turkmenistan",
      value: "Turkmenistan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Turks and Caicos Islands",
      value: "Turks and Caicos Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Tuvalu",
      value: "Tuvalu",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Uganda",
      value: "Uganda",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Ukraine",
      value: "Ukraine",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "United Arab Emirates",
      value: "United Arab Emirates",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "United Kingdom of Great Britain and Northern Ireland",
      value: "United Kingdom of Great Britain and Northern Ireland",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "United States Minor Outlying Islands",
      value: "United States Minor Outlying Islands",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "United States of America",
      value: "United States of America",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Uruguay",
      value: "Uruguay",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Uzbekistan",
      value: "Uzbekistan",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Vanuatu",
      value: "Vanuatu",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Venezuela Bolivarian Republic of",
      value: "Venezuela Bolivarian Republic of",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Vietnam",
      value: "Vietnam",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },

    {
      title: "Virgin Islands, U.S.",
      value: "Virgin Islands, U.S.",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Wallis and Futuna",
      value: "Wallis and Futuna",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Western Sahara",
      value: "Western Sahara",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Yemen",
      value: "Yemen",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Zambia",
      value: "Zambia",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
    {
      title: "Zimbabwe",
      value: "Zimbabwe",
      supportLanguageList: [
        {
          title: "English only",
          value: "en",
        },
      ],
    },
  ],
  nationalityList: [
    { title: "Singaporean", value: "Singaporean" },
    { title: "Malaysian", value: "Malaysian" },
    { title: "Chinese", value: "Chinese" },
    { title: "Chinese/Hong Kong Sar", value: "Chinese/Hong Kong Sar" },
    { title: "Chinese/Macau Sar", value: "Chinese/Macau Sar" },
    { title: "Afghan", value: "Afghan" },
    { title: "Albanian", value: "Albanian" },
    { title: "Algerian", value: "Algerian" },
    { title: "American", value: "American" },
    { title: "Andorran", value: "Andorran" },
    { title: "Angolan", value: "Angolan" },
    { title: "Antiguan", value: "Antiguan" },
    { title: "Argentinian", value: "Argentinian" },
    { title: "Armenian", value: "Armenian" },
    { title: "Australian", value: "Australian" },
    { title: "Austrian", value: "Austrian" },
    { title: "Azerbaijani", value: "Azerbaijani" },
    { title: "Bahamian", value: "Bahamian" },
    { title: "Bahraini", value: "Bahraini" },
    { title: "Bangladeshi", value: "Bangladeshi" },
    { title: "Barbados", value: "Barbados" },
    { title: "Belarussian", value: "Belarussian" },
    { title: "Belgian", value: "Belgian" },
    { title: "Belizeah", value: "Belizeah" },
    { title: "Beninese", value: "Beninese" },
    { title: "Bhutanese", value: "Bhutanese" },
    { title: "Bolivian", value: "Bolivian" },
    { title: "Bosnia", value: "Bosnia" },
    { title: "Batswana", value: "Batswana" },
    { title: "Brazilian", value: "Brazilian" },
    { title: "British", value: "British" },
    { title: "British National Overseas", value: "British National Overseas" },
    { title: "British Overseas Citizen", value: "British Overseas Citizen" },
    { title: "British Overseas Territories Citizen", value: "British Overseas Territories Citizen" },
    { title: "British Protected Person", value: "British Protected Person" },
    { title: "British Subject", value: "British Subject" },
    { title: "Bruneian", value: "Bruneian" },
    { title: "Bulgarian", value: "Bulgarian" },
    { title: "Burkinabe", value: "Burkinabe" },
    { title: "Burundian", value: "Burundian" },
    { title: "Cambodian", value: "Cambodian" },
    { title: "Cameroonian", value: "Cameroonian" },
    { title: "Canadian", value: "Canadian" },
    { title: "Cape Verdean", value: "Cape Verdean" },
    { title: "Cayman Islands", value: "Cayman Islands" },
    { title: "Central African Republic", value: "Central African Republic" },
    { title: "Chadian", value: "Chadian" },
    { title: "Chilean", value: "Chilean" },
    { title: "Chinese/ Taiwanese", value: "Chinese/ Taiwanese" },
    { title: "Colombia", value: "Colombia" },
    { title: "Comoran", value: "Comoran" },
    { title: "Congolese", value: "Congolese" },
    { title: "Costa Rican", value: "Costa Rican" },
    { title: "Croatian", value: "Croatian" },
    { title: "Cuban", value: "Cuban" },
    { title: "Cyprot", value: "Cyprot" },
    { title: "Czech", value: "Czech" },
    { title: "D.P.R.Korean", value: "D.P.R.Korean" },
    { title: "Danish", value: "Danish" },
    { title: "Democratic Republic of the Congo", value: "Democratic Republic of the Congo" },
    { title: "Djiboutian", value: "Djiboutian" },
    { title: "Dominican", value: "Dominican" },
    { title: "Dominican (Republic)", value: "Dominican (Republic)" },
    { title: "East Timorese", value: "East Timorese" },
    { title: "Ecuadorian", value: "Ecuadorian" },
    { title: "Egyptian", value: "Egyptian" },
    { title: "Equatorial Guinea", value: "Equatorial Guinea" },
    { title: "Eritrean", value: "Eritrean" },
    { title: "Estonian", value: "Estonian" },
    { title: "Ethiopian", value: "Ethiopian" },
    { title: "Fijian", value: "Fijian" },
    { title: "Filipino", value: "Filipino" },
    { title: "Finnish", value: "Finnish" },
    { title: "French", value: "French" },
    { title: "Gabon", value: "Gabon" },
    { title: "Gambian", value: "Gambian" },
    { title: "Georgian", value: "Georgian" },
    { title: "German", value: "German" },
    { title: "Ghanaian", value: "Ghanaian" },
    { title: "Greek", value: "Greek" },
    { title: "Grenadian", value: "Grenadian" },
    { title: "Guatemalan", value: "Guatemalan" },
    { title: "Guinean", value: "Guinean" },
    { title: "Guinean (Bissau)", value: "Guinean (Bissau)" },
    { title: "Guyanese", value: "Guyanese" },
    { title: "Haitian", value: "Haitian" },
    { title: "Honduran", value: "Honduran" },
    { title: "Hungarian", value: "Hungarian" },
    { title: "Icelander", value: "Icelander" },
    { title: "Indian", value: "Indian" },
    { title: "Indonesian", value: "Indonesian" },
    { title: "Iranian", value: "Iranian" },
    { title: "Iraqi", value: "Iraqi" },
    { title: "Irish", value: "Irish" },
    { title: "Israeli", value: "Israeli" },
    { title: "Italian", value: "Italian" },
    { title: "Ivory Coast", value: "Ivory Coast" },
    { title: "Jamaican", value: "Jamaican" },
    { title: "Japanese", value: "Japanese" },
    { title: "Jordanian", value: "Jordanian" },
    { title: "Kazakhstani", value: "Kazakhstani" },
    { title: "Kenyan", value: "Kenyan" },
    { title: "Kiribati", value: "Kiribati" },
    { title: "Korean, South", value: "Korean, South" },
    { title: "Kosovar", value: "Kosovar" },
    { title: "Kuwaiti", value: "Kuwaiti" },
    { title: "Kyrgyzstan", value: "Kyrgyzstan" },
    { title: "Laotian", value: "Laotian" },
    { title: "Latvian", value: "Latvian" },
    { title: "Lebanese", value: "Lebanese" },
    { title: "Lesotho", value: "Lesotho" },
    { title: "Liberian", value: "Liberian" },
    { title: "Libyan", value: "Libyan" },
    { title: "Liechtensteiner", value: "Liechtensteiner" },
    { title: "Lithuanian", value: "Lithuanian" },
    { title: "Luxembourger", value: "Luxembourger" },
    { title: "Macedonian", value: "Macedonian" },
    { title: "Malagasy", value: "Malagasy" },
    { title: "Malawian", value: "Malawian" },
    { title: "Maldivian", value: "Maldivian" },
    { title: "Malian", value: "Malian" },
    { title: "Maltese", value: "Maltese" },
    { title: "Marshallese", value: "Marshallese" },
    { title: "Mauritanean", value: "Mauritanean" },
    { title: "Mauritian", value: "Mauritian" },
    { title: "Mexican", value: "Mexican" },
    { title: "Micronesian", value: "Micronesian" },
    { title: "Moldavian", value: "Moldavian" },
    { title: "Monacan", value: "Monacan" },
    { title: "Mongolian", value: "Mongolian" },
    { title: "Montenegrin", value: "Montenegrin" },
    { title: "Moroccan", value: "Moroccan" },
    { title: "Mozambican", value: "Mozambican" },
    { title: "Myanmar", value: "Myanmar" },
    { title: "Namibian", value: "Namibian" },
    { title: "Nauruan", value: "Nauruan" },
    { title: "Nepalese", value: "Nepalese" },
    { title: "Netherlands", value: "Netherlands" },
    { title: "New Zealander", value: "New Zealander" },
    { title: "Ni-Vanuatu", value: "Ni-Vanuatu" },
    { title: "Nicaraguan", value: "Nicaraguan" },
    { title: "Niger", value: "Niger" },
    { title: "Nigerian", value: "Nigerian" },
    { title: "Norwegian", value: "Norwegian" },
    { title: "Omani", value: "Omani" },
    { title: "Pakistani", value: "Pakistani" },
    { title: "Palauan", value: "Palauan" },
    { title: "Palestinian", value: "Palestinian" },
    { title: "Panamanian", value: "Panamanian" },
    { title: "Papua New Guinean", value: "Papua New Guinean" },
    { title: "Paraguayan", value: "Paraguayan" },
    { title: "Peruvian", value: "Peruvian" },
    { title: "Philippine", value: "Philippine" },
    { title: "Polish", value: "Polish" },
    { title: "Portuguese", value: "Portuguese" },
    { title: "Qatari", value: "Qatari" },
    { title: "Romanian", value: "Romanian" },
    { title: "Russian", value: "Russian" },
    { title: "Rwandan", value: "Rwandan" },
    { title: "Salvadorian", value: "Salvadorian" },
    { title: "Sammarinese", value: "Sammarinese" },
    { title: "Samoan", value: "Samoan" },
    { title: "Sao Tomean", value: "Sao Tomean" },
    { title: "Saudi Arabian", value: "Saudi Arabian" },
    { title: "Senegalese", value: "Senegalese" },
    { title: "Serbian", value: "Serbian" },
    { title: "Seychellois", value: "Seychellois" },
    { title: "Sierra Leone", value: "Sierra Leone" },
    { title: "Slovak", value: "Slovak" },
    { title: "Slovenian", value: "Slovenian" },
    { title: "Solomon Islander", value: "Solomon Islander" },
    { title: "Somali", value: "Somali" },
    { title: "South African", value: "South African" },
    { title: "Spanish", value: "Spanish" },
    { title: "Sri Lankan", value: "Sri Lankan" },
    { title: "ST. Lucia", value: "ST. Lucia" },
    { title: "ST. Vincentian", value: "ST. Vincentian" },
    { title: "Stateless", value: "Stateless" },
    { title: "Sudanese", value: "Sudanese" },
    { title: "Surinamer", value: "Surinamer" },
    { title: "Swazi", value: "Swazi" },
    { title: "Swedish", value: "Swedish" },
    { title: "Swiss", value: "Swiss" },
    { title: "Syrian", value: "Syrian" },
    { title: "Tajikistani", value: "Tajikistani" },
    { title: "Tanzanian", value: "Tanzanian" },
    { title: "Thai", value: "Thai" },
    { title: "Togolese", value: "Togolese" },
    { title: "Tongan", value: "Tongan" },
    { title: "Trinidadian & Tobagonian", value: "Trinidadian & Tobagonian" },
    { title: "Tunisian", value: "Tunisian" },
    { title: "Turk", value: "Turk" },
    { title: "Turkmen", value: "Turkmen" },
    { title: "Tuvalu", value: "Tuvalu" },
    { title: "Ugandan", value: "Ugandan" },
    { title: "Ukrainian", value: "Ukrainian" },
    { title: "United Arab Emirates", value: "United Arab Emirates" },
    { title: "Uruguayan", value: "Uruguayan" },
    { title: "Uzbekistan", value: "Uzbekistan" },
    { title: "Vatican City State (Holy See)", value: "Vatican City State (Holy See)" },
    { title: "Venezuelan", value: "Venezuelan" },
    { title: "Vietnamese", value: "Vietnamese" },
    { title: "Yemeni", value: "Yemeni" },
    { title: "Zambian", value: "Zambian" },
    { title: "Zimbabwean", value: "Zimbabwean" },
  ],
  companyMemberTypes: [
    {
      title: "Individual",
      value: "INDIVIDUAL",
    },
    {
      title: "Company",
      value: "CORPORATE",
    },
  ],
  positionHelds: [
    {
      title: "Shareholder",
      value: "SHAREHOLDER",
      selectable: ["CORPORATE", "INDIVIDUAL"],
    },
    {
      title: "Director",
      value: "DIRECTOR",
      selectable: ["INDIVIDUAL"],
    },
    {
      title: "Shareholder+Director",
      value: "DIRECTOR_AND_SHAREHOLDER",
      selectable: ["INDIVIDUAL"],
    },
    {
      title: "Nominee Director",
      value: "NOMINEE_DIRECTOR",
      selectable: [],
    },
  ],
  typeOfShares: [
    {
      title: "Ordinary",
      value: "Ordinary",
    },
    {
      title: "Preference",
      value: "Preference",
    },
    {
      title: "Others",
      value: "Others",
    },
  ],
  stepStatusList: [
    {
      title: "Rejected",
      value: 0,
    },
    {
      title: "Pass",
      value: 1,
    },
    {
      title: "Revised",
      value: 2,
      unselectable: true,
    },
    {
      title: "No Checking",
      value: 3,
      unselectable: true,
    },
  ],
  companyTypeList: [
    {
      title: "Exempt Private Company Limited by Shares",
      value: "Exempt Private Company Limited by Shares",
    },
    {
      title: "Private Company Limited by Shares",
      value: "Private Company Limited by Shares",
    },
    // {
    //   title: "Public Company Limited By Gurantee",
    //   value: "Public Company Limited By Gurantee",
    // },
    // {
    //   title: "Public Company Limited By Shares",
    //   value: "Public Company Limited By Shares",
    // },
    // {
    //   title: "Unlimited Exempt Private Company",
    //   value: "Unlimited Exempt Private Company",
    // },
    // {
    //   title: "Unlimited Private Company",
    //   value: "Unlimited Private Company",
    // },
    // {
    //   title: "Unlimited Public Company",
    //   value: "Unlimited Public Company",
    // },
  ],
  companyTypeSuffixList: {
    "Exempt Private Company Limited by Shares": [
      "PRIVATE LIMITED",
      "PRIVATE LTD.",
      "PTE. LIMITED",
      "PTE. LTD.",
      "SDN. BERHAD",
      "SDN. BHD.",
      "SENDIRIAN BERHAD",
      "SENDIRIAN BHD.",
      "(PRIVATE LIMITED)",
      "(PRIVATE LTD.)",
      "(PTE. LIMITED)",
      "(PTE. LTD.)",
      "(PTE.) LIMITED",
      "(PTE.) LTD.",
      "(SDN. BERHAD)",
      "(SDN. BHD.)",
      "(SDN.) BERHAD",
      "(SDN.) BHD.",
      "(SENDIRIAN BERHAD)",
      "(SENDIRIAN BHD.)",
      "(SENDIRIAN) BERHAD",
      "(SENDIRIAN) BHD.",
    ],

    "Private Company Limited by Shares": [
      "PRIVATE LIMITED",
      "PRIVATE LTD.",
      "PTE. LIMITED",
      "PTE. LTD.",
      "SDN. BERHAD",
      "SDN. BHD.",
      "SENDIRIAN BERHAD",
      "SENDIRIAN BHD.",
      "(PRIVATE LIMITED)",
      "(PRIVATE LTD.)",
      "(PTE. LIMITED)",
      "(PTE. LTD.)",
      "(PTE.) LIMITED",
      "(PTE.) LTD.",
      "LAW CORPORATION",
      "LLC",
      "PAC",
      "(LAW CORPORATION)",
      "(LLC)",
      "(PAC)",
      "(SDN. BERHAD)",
      "(SDN. BHD.)",
      "(SDN.) BERHAD",
      "(SDN.) BHD.",
      "(SENDIRIAN BERHAD)",
      "(SENDIRIAN BHD.)",
      "(SENDIRIAN) BERHAD",
      "(SENDIRIAN) BHD.",
    ],

    "Public Company Limited By Gurantee": ["BERHAD", "BHD.", "LIMITED", "LTD.", "(BERHAD)", "(BHD.)", "(LIMITED)", "(LTD.)"],
    "Public Company Limited By Shares": ["BERHAD", "BHD.", "LIMITED", "LTD.", "(BERHAD)", "(BHD.)", "(LIMITED)", "(LTD.)"],

    "Unlimited Exempt Private Company": ["PRIVATE", "PTE.", "SDN.", "SENDIRIAN", "(PRIVATE)", "(PTE.)", "(SDN.)", "(SENDIRIAN)"],
    "Unlimited Private Company": ["PRIVATE", "PTE.", "SDN.", "SENDIRIAN", "(PRIVATE)", "(PTE.)", "(SDN.)", "(SENDIRIAN)"],

    "Unlimited Public Company": ["UNLIMITED", "(UNLIMITED)"],
  },
  workingHoursOptions: [
    {
      title: "At least 5 hours during ordinary business hours on each business day",
      value: "at least 5",
    },
    {
      title: "At least 3 hours but less than 5 hours during ordinary business hours on each business day",
      value: "3 to 5",
    },
  ],
  customizedConstitutionOptions: [
    {
      title: "Standard constitution",
      value: 0,
    },
    {
      title: "Customized constitution (customized constitution reviewed by legal is required to be uploaded in the next step under this option)",
      value: 1,
    },
  ],
  currencyOptions: [
    {
      value: "SGD",
      title: "SGD Singapore, Dollars",
    },
    {
      value: "MYR",
      title: "MYR MALAYSIA, RINGGIT",
    },
    {
      value: "USD",
      title: "USD United States of America, Dollars",
    },
    {
      value: "CNY",
      title: "CNY China, Yuan Renminbi",
    },
    {
      value: "HKD",
      title: "HKD Hong Kong, Dollars",
    },
    {
      value: "AFN",
      title: "AFN AFGHANISTAN, AFGHANI",
    },
    {
      value: "ALL",
      title: "ALL ALBANIA, LEK",
    },
    {
      value: "DZD",
      title: "DZD ALGERIA, DINARS",
    },
    {
      value: "AOA",
      title: "AOA ANGOLA, KWANZA",
    },
    {
      value: "ARS",
      title: "ARS ARGENTINA, PESOS",
    },
    {
      value: "AMD",
      title: "AMD ARENIA, DRAMS",
    },
    {
      value: "AWG",
      title: "AWG ARUBAN, FLORIN",
    },
    {
      value: "AUD",
      title: "AUD AUSTRALIA, DOLLARS",
    },
    {
      value: "AZN",
      title: "AZN AZERBAIJAN, MANAT",
    },
    {
      value: "BSD",
      title: "BSD BAHAMAS, DOLLARS",
    },
    {
      value: "BHD",
      title: "BHD BAHRAIN, DINARS",
    },
    {
      value: "BDT",
      title: "BDT BANGLADESH, TAKA",
    },
    {
      value: "BBD",
      title: "BBD BARBADOS, DOLLARS",
    },
    {
      value: "BYN",
      title: "BYN BELARUS, RUBLES",
    },
    {
      value: "BYR",
      title: "BYR BELARUSIAN, RUBEL",
    },
    {
      value: "BZD",
      title: "BZD BELIZE, DOLLARS",
    },
    {
      value: "BMD",
      title: "BMD BERMUDA, DOLLARS",
    },
    {
      value: "BTN",
      title: "BTN BHUTAN, NGULTRUM",
    },
    {
      value: "VEF",
      title: "VEF BOLÍVAR, FUERTE",
    },
    {
      value: "BOV",
      title: "BOV BOLIVIAN, MVDOL",
    },
    {
      value: "BOB",
      title: "BOB BOLIVIANO, ",
    },
    {
      value: "XBA",
      title: "XBA BOND MARKETS UNITS, EUROPEAN COMPOSITE UNIT",
    },
    {
      value: "BAM",
      title: "BAM BOSNIA AND HERZEGOVINA, CONVERTIBLE MARK",
    },
    {
      value: "BWP",
      title: "BWP BOTSWANA, PULAS",
    },
    {
      value: "BRL",
      title: "BRL BRAZIL, REAL",
    },
    {
      value: "BND",
      title: "BND BRUNEI DARUSSALAM, DOLLARS",
    },
    {
      value: "BGN",
      title: "BGN BULGARIA, LEV",
    },
    {
      value: "BIF",
      title: "BIF BURUNDI, FRANCS",
    },
    {
      value: "KHR",
      title: "KHR CAMBODIA, RIELS",
    },
    {
      value: "CAD",
      title: "CAD CANADA, DOLLARS",
    },
    {
      value: "CVE",
      title: "CVE CAPE VERDE, ESCUDOS",
    },
    {
      value: "KYD",
      title: "KYD CAYMAN ISLANDS, DOLLARS",
    },
    {
      value: "GHS",
      title: "GHS CEDI",
    },
    {
      value: "CLP",
      title: "CLP CHILE, PESOS",
    },
    {
      value: "COP",
      title: "COP COLOMBIA, PESOS",
    },
    {
      value: "XAF",
      title: "XAF COMMUNAUTE FINANCIERE AFRICAINE BEATS, FRANCS",
    },
    {
      value: "XOF",
      title: "XOF COMMUNAUTE FINANCIERE AFRICAINE FRANCS BCEAO, FRANCS",
    },
    {
      value: "KMF",
      title: "KMF COMOROS, FRANCS",
    },
    {
      value: "XPF",
      title: "XPF COMPTOIRS FRANCAIS DU PACIFIQUE, FRANCS",
    },
    {
      value: "CDF",
      title: "CDF CONGOLESE, FRANCS",
    },
    {
      value: "NIO",
      title: "NIO CÓRDOBA, ORO",
    },
    {
      value: "CRC",
      title: "CRC COSTA RICA, COLONES",
    },
    {
      value: "HRK",
      title: "HRK CROATIA, KUNA",
    },
    {
      value: "CUP",
      title: "CUP CUBA, PESOS",
    },
    {
      value: "CYP",
      title: "CYP CYPRUS, POUNDS",
    },
    {
      value: "CZK",
      title: "CZK CZECHIA, KORUNA",
    },
    {
      value: "DKK",
      title: "DKK DANISH, KRONE",
    },
    {
      value: "DJF",
      title: "DJF DJIBOUTI, FRANCS",
    },
    {
      value: "DOP",
      title: "DOP DOMINICAN REPUBLIC, PESOS",
    },
    {
      value: "XCD",
      title: "XCD EAST CARIBBEAN, DOLLARS",
    },
    {
      value: "EGP",
      title: "EGP EGYPT, POUNDS",
    },
    {
      value: "SVC",
      title: "SVC EL SALVADOR, COLONES",
    },
    {
      value: "ERN",
      title: "ERN ERITREA, NAKFA",
    },
    {
      value: "EEK",
      title: "EEK ESTONIA, KROONI",
    },
    {
      value: "ETB",
      title: "ETB ETHIOPIA, BIRR",
    },
    {
      value: "EUR",
      title: "EUR EURO MEMBER COUNTRIES, EURO",
    },
    {
      value: "XBB",
      title: "XBB EUROPEAN MONETARY UNIT, ",
    },
    {
      value: "XBC",
      title: "XBC EUROPEAN UNIT OF ACCOUNT, ",
    },
    {
      value: "XBD",
      title: "XBD EUROPEAN UNIT OF ACCOUNT, ",
    },
    {
      value: "FKP",
      title: "FKP FALKLAND ISLANDS(MALVINAS), POUNDS",
    },
    {
      value: "FJD",
      title: "FJD FIJI, DOLLARS",
    },
    {
      value: "GMD",
      title: "GMD GAMBIA, DALASI",
    },
    {
      value: "GEL",
      title: "GEL GEORGIA, LARI",
    },
    {
      value: "GHC",
      title: "GHC GHANA, CEDIS",
    },
    {
      value: "GIP",
      title: "GIP GIBRALTAR, POUNDS",
    },
    {
      value: "XAU",
      title: "XAU GOLD, OUNCES",
    },
    {
      value: "GTQ",
      title: "GTQ GUATEALA, QUETZALES",
    },
    {
      value: "GGP",
      title: "GGP GUERNSEY, POUNDS",
    },
    {
      value: "GNF",
      title: "GNF GUINEA, FRANCS",
    },
    {
      value: "GYD",
      title: "GYD GUYANA, DOLLARS",
    },
    {
      value: "HTG",
      title: "HTG HAITI, GOURDES",
    },
    {
      value: "HNL",
      title: "HNL HONDURAS, LEMPIRAS",
    },
    {
      value: "HUF",
      title: "HUF HUNGARY, FORINT",
    },
    {
      value: "ISK",
      title: "ISK ICELANDIC, KRONA",
    },
    {
      value: "INR",
      title: "INR INDIA, REPEES",
    },
    {
      value: "IDR",
      title: "IDR INDONESIA, RUPIAHS",
    },
    {
      value: "XDR",
      title: "XDR INTERNATIONAL MONETARY FUND(IMF), SPECIAL DRAWING RIGHTS",
    },
    {
      value: "IRR",
      title: "IRR IRAN, RIALS",
    },
    {
      value: "IQD",
      title: "IQD IRAQ, DINARS",
    },
    {
      value: "IMP",
      title: "IMP ISLE OF MAN, POUNDS",
    },
    {
      value: "ILS",
      title: "ILS ISRAEL, NEW SHEKELS",
    },
    {
      value: "JMD",
      title: "JMD JAMAICA, DOLLARS",
    },
    {
      value: "JPY",
      title: "JPY JAPAN, YEN",
    },
    {
      value: "JEP",
      title: "JEP JERSEY, POUNDS",
    },
    {
      value: "JOD",
      title: "JOD JORDAN, DINARS",
    },
    {
      value: "KZT",
      title: "KZT KAZAKHSTAN, TENGE",
    },
    {
      value: "KES",
      title: "KES KENYA, SHILLINGS",
    },
    {
      value: "KRI",
      title: "KRI KIRIBATI, DOLLAR",
    },
    {
      value: "KPW",
      title: "KPW KOREA(NORTH), WON",
    },
    {
      value: "KRW",
      title: "KRW KOREA(SOUTH), WON",
    },
    {
      value: "KWD",
      title: "KWD KUWAIT, DINARS",
    },
    {
      value: "KGS",
      title: "KGS KYRGYZSTAN, SOMS",
    },
    {
      value: "LAK",
      title: "LAK LAOS, KIPS",
    },
    {
      value: "LVL",
      title: "LVL LATVIAN, LATS",
    },
    {
      value: "LBP",
      title: "LBP LEBANON, POUNDS",
    },
    {
      value: "LSL",
      title: "LSL LESOTHO, LOTI",
    },
    {
      value: "LRD",
      title: "LRD LIBERIA, DOLLARS",
    },
    {
      value: "LYD",
      title: "LYD LIBYA, DINARS",
    },
    {
      value: "LTL",
      title: "LTL LITHUANIAN, LITAS",
    },
    {
      value: "MOP",
      title: "MOP MACAU, PATACAS",
    },
    {
      value: "MKD",
      title: "MKD MACEDONIA, DENARS",
    },
    {
      value: "MGA",
      title: "MGA MADAGASCAR, ARIARY",
    },
    {
      value: "MWK",
      title: "MWK MALAWI, KWACHAS",
    },
    {
      value: "MVR",
      title: "MVR MALDIVES (MALDIVE ISLANDS), RUFIYAA",
    },
    {
      value: "MTL",
      title: "MTL MALTA, LIRI",
    },
    {
      value: "MRO",
      title: "MRO MAURITANIA, OUGUIYAS",
    },
    {
      value: "MRU",
      title: "MRU MAURITANIA, OUGUIYAS",
    },
    {
      value: "MUR",
      title: "MUR MAURITIUS, RUPEE",
    },
    {
      value: "MXV",
      title: "MXV MEXICAN, UNIDAD DE INVERSION(UDI)",
    },
    {
      value: "MXN",
      title: "MXN MEXICO, MEXICAN PESO",
    },
    {
      value: "MDL",
      title: "MDL MOLDOVA, LEU",
    },
    {
      value: "MNT",
      title: "MNT MONGOLIA, TUGRIKS",
    },
    {
      value: "MAD",
      title: "MAD MOROCCO, DIRHAMS",
    },
    {
      value: "MZN",
      title: "MZN MOZAMBIQUE, METICALS",
    },
    {
      value: "MMK",
      title: "MMK MYANMAR(BURMA), KYATS",
    },
    {
      value: "NAD",
      title: "NAD NAMIBIA, DOLLARS",
    },
    {
      value: "NPR",
      title: "NPR NEPAL, NEPALESE RUPEE",
    },
    {
      value: "ANG",
      title: "ANG NETHERLANDS ANTILLES, GUILDERS",
    },
    {
      value: "NZD",
      title: "NZD NEW ZEALAND, DOLLARS",
    },
    {
      value: "NGN",
      title: "NGN NIGERIA, NAIRAS",
    },
    {
      value: "XXX",
      title: "XXX NO CURRENCY, ",
    },
    {
      value: "NOK",
      title: "NOK NORWEGIAN, KRONE",
    },
    {
      value: "OMR",
      title: "OMR OMAN, RIALS",
    },
    {
      value: "OTH",
      title: "OTH OTHERS",
    },
    {
      value: "PKR",
      title: "PKR PAKISTAN, RUPEES",
    },
    {
      value: "XPD",
      title: "XPD PALLADIUM, OUNCES",
    },
    {
      value: "PAB",
      title: "PAB PANAMA, BALBOA",
    },
    {
      value: "PGK",
      title: "PGK PAPUA NEW GUINEA, KINA",
    },
    {
      value: "PYG",
      title: "PYG PARAGUAY, GUARANÍ",
    },
    {
      value: "PEN",
      title: "PEN PERU, NUEVO SOLES",
    },
    {
      value: "CUC",
      title: "CUC PESO, CONVERTIBLE",
    },
    {
      value: "PHP",
      title: "PHP PHILIPPINES, PESOS",
    },
    {
      value: "XPT",
      title: "XPT PLATINUM, OUNCES",
    },
    {
      value: "PLN",
      title: "PLN POLISH, ZLOTY",
    },
    {
      value: "QAR",
      title: "QAR QATAR, RIALS",
    },
    {
      value: "RON",
      title: "RON ROMANIA, LEU",
    },
    {
      value: "RUB",
      title: "RUB RUSSIA, REBELS",
    },
    {
      value: "RWF",
      title: "RWF RWANDA, FRANCS",
    },
    {
      value: "SHP",
      title: "SHP SAINT HELENA, POUNDS",
    },
    {
      value: "WST",
      title: "WST SAMOA, TALA",
    },
    {
      value: "STD",
      title: "STD SAO TOME AND PRINCIPE, ",
    },
    {
      value: "STN",
      title: "STN SAO TOME AND PRINCIPE, DOBRAS",
    },
    {
      value: "SAR",
      title: "SAR SAUDI ARABIA, RIYALS",
    },
    {
      value: "SPL",
      title: "SPL SEBORGA, LUIGINI",
    },
    {
      value: "RSD",
      title: "RSD SERBIA, DINARS",
    },
    {
      value: "SCR",
      title: "SCR SEYCHELLES, RUPEES",
    },
    {
      value: "SLL",
      title: "SLL SIERRA LEONE, LEONES",
    },
    {
      value: "XAG",
      title: "XAG SILVER, OUNCES",
    },
    {
      value: "SKK",
      title: "SKK SLOVAKIA, KORUNY",
    },
    {
      value: "SBD",
      title: "SBD SOLOMON ISLANDS, DOLLARS",
    },
    {
      value: "SOS",
      title: "SOS SOMALIA, SHILLINGS",
    },
    {
      value: "SLS",
      title: "SLS SOMALILAND, SHILLING",
    },
    {
      value: "ZAR",
      title: "ZAR SOUTH AFRICA, RAND",
    },
    {
      value: "SSP",
      title: "SSP SOUTH SUDANESE, POUND",
    },
    {
      value: "LKR",
      title: "LKR SRI LANKA, RUPEES",
    },
    {
      value: "SDD",
      title: "SDD SUDAN, POUND",
    },
    {
      value: "SDG",
      title: "SDG SUDANESE, POUND",
    },
    {
      value: "SRD",
      title: "SRD SURINAME, DOLLARS",
    },
    {
      value: "SZL",
      title: "SZL SWAZI, LILANGENI",
    },
    {
      value: "SEK",
      title: "SEK SWEDEN, KRONOR",
    },
    {
      value: "CHF",
      title: "CHF SWITZERLAND, FRANCS",
    },
    {
      value: "SYP",
      title: "SYP SYRIAN, POUND",
    },
    {
      value: "TWD",
      title: "TWD TAIWAN, NEW DOLLAR",
    },
    {
      value: "TJS",
      title: "TJS TAJIKISTAN, SOMONI",
    },
    {
      value: "TZS",
      title: "TZS TANZANIA, SHILLINGS",
    },
    {
      value: "THB",
      title: "THB THAILAND, BAHT",
    },
    {
      value: "TOP",
      title: "TOP TONGA, PA'ANGA",
    },
    {
      value: "PRB",
      title: "PRB TRANSNISTRIAN, RUBLE",
    },
    {
      value: "TTD",
      title: "TTD TRINIDAD AND TOBAGO, DOLLARS",
    },
    {
      value: "TND",
      title: "TND TUNISIA, DINARS",
    },
    {
      value: "TRY",
      title: "TRY TURKISH, LIRA",
    },
    {
      value: "TMT",
      title: "TMT TURKMENISTAN, NEW MANAT",
    },
    {
      value: "TMM",
      title: "TMM TURKMENISTAN, MANATS",
    },
    {
      value: "TVD",
      title: "TVD TUVALU, TUVALUAN DOLLARS",
    },
    {
      value: "UGX",
      title: "UGX UGANDA, SHILLINGS",
    },
    {
      value: "XFU",
      title: "XFU UIC, FRANC",
    },
    {
      value: "UAH",
      title: "UAH UKRAINE, HRYWNJA",
    },
    {
      value: "COU",
      title: "COU UNIDAD, DE VALOR REAL",
    },
    {
      value: "CLF",
      title: "CLF UNIDADES, DE FOMENTO",
    },
    {
      value: "AED",
      title: "AED UNITED ARAB EMIRATES, DIRHAMS",
    },
    {
      value: "GBP",
      title: "GBP UNITED KINGDOM, POUNDS",
    },
    {
      value: "USN",
      title: "USN UNITED STATES DOLLAR(NEXT DAY), FUNDS CODE",
    },
    {
      value: "USS",
      title: "USS UNITED STATES DOLLAR(SAME DAY), FUNDS CODE",
    },
    {
      value: "UYU",
      title: "UYU URUGUAY, PESOS",
    },
    {
      value: "UYW",
      title: "UYW URUGUAY, UNIDAD PREVISONAL",
    },
    {
      value: "UYI",
      title: "UYI URUGUAY PESO EN UNIDADES INDEXADSA (URUIURUI) (FUNDS CODE)",
    },
    {
      value: "UZS",
      title: "UZS UZBEKISTAN, SUMS",
    },
    {
      value: "VUV",
      title: "VUV VANUATU, VATU",
    },
    {
      value: "VEB",
      title: "VEB VENEZUELA, BOLIVARES",
    },
    {
      value: "VES",
      title: "VES VENEZUELA(BOLIVARIAN REPUBLIC OF), BOLIVAR SOBERANO",
    },
    {
      value: "VND",
      title: "VND VIETNAM, DONG",
    },
    {
      value: "CHE",
      title: "CHE WIR, EURO",
    },
    {
      value: "CHW",
      title: "CHW WIR, FRANC",
    },
    {
      value: "YER",
      title: "YER YEMEN, RIALS",
    },
    {
      value: "ZMK",
      title: "ZMK ZAMBIA, KWACHA",
    },
  ],
  prefixOptions: [
    {
      value: "65",
      title: "Singapore",
    },
    {
      value: "60",
      title: "Malaysia",
    },
    {
      value: "86",
      title: "China",
    },
    {
      value: "852",
      title: "Chinese/Hong Kong Sar",
    },
    {
      value: "853",
      title: "Chinese/Macau Sar",
    },
    {
      value: "886",
      title: "Chinese/Taiwan",
    },
    {
      value: "93",
      title: "Afghanistan",
    },
    {
      value: "355",
      title: "Albania",
    },
    {
      value: "213",
      title: "Algera",
    },
    {
      value: "376",
      title: "Andorra",
    },
    {
      value: "244",
      title: "Angola",
    },
    {
      value: "1264",
      title: "Anguilla",
    },
    {
      value: "247",
      title: "Ascension",
    },
    {
      value: "1268",
      title: "Antigua and Barbuda",
    },
    {
      value: "54",
      title: "Argentina",
    },
    {
      value: "374",
      title: "Armenia",
    },
    {
      value: "297",
      title: "Aruba",
    },
    {
      value: "61",
      title: "Australia",
    },
    {
      value: "43",
      title: "Austria",
    },
    {
      value: "994",
      title: "Azerbaijan",
    },
    {
      value: "1242",
      title: "Bahamas",
    },
    {
      value: "973",
      title: "Bahrain",
    },
    {
      value: "880",
      title: "Bangladesh",
    },
    {
      value: "1246",
      title: "Barbados",
    },
    {
      value: "375",
      title: "Belarus",
    },
    {
      value: "32",
      title: "Belgium",
    },
    {
      value: "501",
      title: "Belize",
    },
    {
      value: "229",
      title: "Benin",
    },
    {
      value: "1441",
      title: "Bermuda",
    },
    {
      value: "975",
      title: "Bhutan",
    },
    {
      value: "591",
      title: "Bolivia",
    },
    {
      value: "387",
      title: "Bosnia and Herzegovina",
    },
    {
      value: "267",
      title: "Botwana",
    },
    {
      value: "55",
      title: "Brazill",
    },
    {
      value: "673",
      title: "Brunei",
    },
    {
      value: "359",
      title: "Bulgaria",
    },
    {
      value: "226",
      title: "Burkina Faso",
    },
    {
      value: "257",
      title: "Burundi",
    },
    {
      value: "855",
      title: "Cambodia",
    },
    {
      value: "237",
      title: "Cameroon",
    },
    {
      value: "1",
      title: "Canada",
    },
    {
      value: "238",
      title: "Cape Verde",
    },
    {
      value: "1345",
      title: "Cayman Islands",
    },
    {
      value: "236",
      title: "Central African Republic",
    },
    {
      value: "235",
      title: "Chad",
    },
    {
      value: "56",
      title: "Chile",
    },
    {
      value: "57",
      title: "Colombia",
    },
    {
      value: "269",
      title: "Comoros",
    },
    {
      value: "242",
      title: "Republic of the Congo",
    },
    {
      value: "243",
      title: "Democratic Republic of the Congo",
    },
    {
      value: "682",
      title: "Cook Islands",
    },
    {
      value: "506",
      title: "Costa Rica",
    },
    {
      value: "225",
      title: "Cote divoire",
    },
    {
      value: "385",
      title: "Croatia",
    },
    {
      value: "53",
      title: "Cuba",
    },
    {
      value: "357",
      title: "Cyprus",
    },
    {
      value: "420",
      title: "Czech Republic",
    },
    {
      value: "45",
      title: "Denmark",
    },
    {
      value: "253",
      title: "Djibouti",
    },
    {
      value: "1767",
      title: "Dominica",
    },
    {
      value: "1809",
      title: "Dominican Republic",
    },
    {
      value: "593",
      title: "Ecuador",
    },
    {
      value: "20",
      title: "Egypt",
    },
    {
      value: "503",
      title: "EISalvador",
    },
    {
      value: "372",
      title: "Estonia",
    },
    {
      value: "251",
      title: "Ethiopia",
    },
    {
      value: "298",
      title: "Faroe Islands",
    },
    {
      value: "679",
      title: "Fiji",
    },
    {
      value: "358",
      title: "Finland",
    },
    {
      value: "33",
      title: "France",
    },
    {
      value: "594",
      title: "French Guiana",
    },
    {
      value: "689",
      title: "French Polynesia",
    },
    {
      value: "241",
      title: "Gabon",
    },
    {
      value: "220",
      title: "Gambia",
    },
    {
      value: "995",
      title: "Georgia",
    },
    {
      value: "94",
      title: "Germany",
    },
    {
      value: "233",
      title: "Ghana",
    },
    {
      value: "350",
      title: "Gibraltar",
    },
    {
      value: "30",
      title: "Greece",
    },
    {
      value: "299",
      title: "Greenland",
    },
    {
      value: "1473",
      title: "Grenada",
    },
    {
      value: "590",
      title: "Guadeloupe",
    },
    {
      value: "1671",
      title: "Guam",
    },
    {
      value: "502",
      title: "Guatemala",
    },
    {
      value: "240",
      title: "Equatorial Guinea",
    },
    {
      value: "245",
      title: "Guinea-Bissau",
    },
    {
      value: "44",
      title: "Guernsey",
    },
    {
      value: "224",
      title: "Guinea",
    },
    {
      value: "592",
      title: "Guyana",
    },
    {
      value: "509",
      title: "Haiti",
    },
    {
      value: "504",
      title: "Honduras",
    },
    {
      value: "95",
      title: "Myanmar",
    },
    {
      value: "36",
      title: "Hungary",
    },
    {
      value: "354",
      title: "Iceland",
    },
    {
      value: "91",
      title: "Indea",
    },
    {
      value: "62",
      title: "Indonesia",
    },
    {
      value: "98",
      title: "Iran",
    },
    {
      value: "964",
      title: "Iraq",
    },
    {
      value: "353",
      title: "Ireland",
    },
    {
      value: "44",
      title: "Isle of Man",
    },
    {
      value: "972",
      title: "Israel",
    },
    {
      value: "93",
      title: "Italy",
    },
    {
      value: "1876",
      title: "Jamaica",
    },
    {
      value: "81",
      title: "Japan",
    },
    {
      value: "44",
      title: "Jersey",
    },
    {
      value: "962",
      title: "Jordan",
    },
    {
      value: "7",
      title: "Kazeakhstan",
    },
    {
      value: "254",
      title: "Kenya",
    },
    {
      value: "383",
      title: "Kosovo",
    },
    {
      value: "965",
      title: "Kuwait",
    },
    {
      value: "996",
      title: "Kyrgyzstan",
    },
    {
      value: "856",
      title: "Laos",
    },
    {
      value: "371",
      title: "Latvia",
    },
    {
      value: "961",
      title: "Lebanon",
    },
    {
      value: "266",
      title: "Lesotho",
    },
    {
      value: "231",
      title: "Liberia",
    },
    {
      value: "218",
      title: "Libya",
    },
    {
      value: "423",
      title: "Liechtenstein",
    },
    {
      value: "370",
      title: "Lithuania",
    },
    {
      value: "352",
      title: "Luxembourg",
    },
    {
      value: "389",
      title: "Macedonia",
    },
    {
      value: "261",
      title: "Madagascar",
    },
    {
      value: "265",
      title: "Malawi",
    },
    {
      value: "960",
      title: "Maldives",
    },
    {
      value: "223",
      title: "Mali",
    },
    {
      value: "356",
      title: "Malta",
    },
    {
      value: "596",
      title: "Martinique",
    },
    {
      value: "222",
      title: "Mauritania",
    },
    {
      value: "230",
      title: "Mauritius",
    },
    {
      value: "262",
      title: "Mayotte",
    },
    {
      value: "52",
      title: "Mexico",
    },
    {
      value: "373",
      title: "Moldova",
    },
    {
      value: "377",
      title: "Monaco",
    },
    {
      value: "976",
      title: "Mongolia",
    },
    {
      value: "382",
      title: "Montenegro",
    },
    {
      value: "1664",
      title: "Montserrat",
    },
    {
      value: "212",
      title: "Morocco",
    },
    {
      value: "258",
      title: "Mozambique",
    },
    {
      value: "264",
      title: "Namibia",
    },
    {
      value: "977",
      title: "Nepal",
    },
    {
      value: "31",
      title: "Netherlands",
    },
    {
      value: "599",
      title: "Netherlands Antillse",
    },
    {
      value: "687",
      title: "New Caledonia",
    },
    {
      value: "64",
      title: "NewZealand",
    },
    {
      value: "505",
      title: "Nicaragua",
    },
    {
      value: "227",
      title: "Niger",
    },
    {
      value: "234",
      title: "Nigeria",
    },
    {
      value: "47",
      title: "Norway",
    },
    {
      value: "968",
      title: "Oman",
    },
    {
      value: "92",
      title: "Pakistan",
    },
    {
      value: "970",
      title: "Palestinian",
    },
    {
      value: "507",
      title: "Panama",
    },
    {
      value: "675",
      title: "Papua New Guinea",
    },
    {
      value: "595",
      title: "Paraguay",
    },
    {
      value: "51",
      title: "Peru",
    },
    {
      value: "63",
      title: "Philippines",
    },
    {
      value: "48",
      title: "Poland",
    },
    {
      value: "351",
      title: "Portugal",
    },
    {
      value: "1",
      title: "PuertoRico",
    },
    {
      value: "974",
      title: "Qotar",
    },
    {
      value: "262",
      title: "Reunion",
    },
    {
      value: "40",
      title: "Romania",
    },
    {
      value: "7",
      title: "Russia",
    },
    {
      value: "250",
      title: "Rwanda",
    },
    {
      value: "684",
      title: "Samoa Eastern",
    },
    {
      value: "685",
      title: "Samoa Western",
    },
    {
      value: "378",
      title: "San Marino",
    },
    {
      value: "239",
      title: "Sao Tome and Principe",
    },
    {
      value: "966",
      title: "Saudi Arabia",
    },
    {
      value: "221",
      title: "Senegal",
    },
    {
      value: "381",
      title: "Serbia",
    },
    {
      value: "248",
      title: "Seychelles",
    },
    {
      value: "232",
      title: "Sierra Leone",
    },
    {
      value: "421",
      title: "Slovakia",
    },
    {
      value: "386",
      title: "Slovenia",
    },
    {
      value: "27",
      title: "South Africa",
    },
    {
      value: "82",
      title: "Korea",
    },
    {
      value: "34",
      title: "Spain",
    },
    {
      value: "94",
      title: "SriLanka",
    },
    {
      value: "1869",
      title: "St Kitts and Nevis",
    },
    {
      value: "1758",
      title: "St.Lucia",
    },
    {
      value: "1784",
      title: "St.Vincent",
    },
    {
      value: "249",
      title: "Sudan",
    },
    {
      value: "597",
      title: "Suriname",
    },
    {
      value: "268",
      title: "Swaziland",
    },
    {
      value: "46",
      title: "Sweden",
    },
    {
      value: "41",
      title: "Switzerland",
    },
    {
      value: "963",
      title: "Syria",
    },
    {
      value: "992",
      title: "Tajikistan",
    },
    {
      value: "255",
      title: "Tanzania",
    },
    {
      value: "66",
      title: "Thailand",
    },
    {
      value: "670",
      title: "Timor Leste",
    },
    {
      value: "228",
      title: "Togo",
    },
    {
      value: "676",
      title: "Tonga",
    },
    {
      value: "1868",
      title: "Trinidad and Tobago",
    },
    {
      value: "216",
      title: "Tunisia",
    },
    {
      value: "90",
      title: "Turkey",
    },
    {
      value: "993",
      title: "Turkmenistan",
    },
    {
      value: "1649",
      title: "Turks and Caicos Islands",
    },
    {
      value: "256",
      title: "Uganda",
    },
    {
      value: "380",
      title: "Ukraine",
    },
    {
      value: "971",
      title: "United Arab Emirates",
    },
    {
      value: "44",
      title: "United Kingdom",
    },
    {
      value: "1",
      title: "USA",
    },
    {
      value: "598",
      title: "Uruguay",
    },
    {
      value: "998",
      title: "Uzbekistan",
    },
    {
      value: "678",
      title: "Vanuatu",
    },
    {
      value: "58",
      title: "Venezuela",
    },
    {
      value: "84",
      title: "Vietnam",
    },
    {
      value: "1284",
      title: "Virgin Islands, British",
    },
    {
      value: "1340",
      title: "Virgin Islands, U.S.",
    },
    {
      value: "967",
      title: "Yemen",
    },
    {
      value: "260",
      title: "Zambia",
    },
    {
      value: "263",
      title: "Zimbabwe",
    },
  ],
  // 申请单角色列表
  ownershipRoleOptions: [
    {
      value: "coordinator",
      title: "Coordinator",
    },
    {
      value: "checker",
      title: "Checker",
    },
    {
      value: "auditor",
      title: "Reviewer",
    },
  ],
  // 申请单角色分配类型
  ownershipTypeOptions: [
    {
      value: "CLAIM",
      title: "self-claimed",
    },
    {
      value: "TRANSFER",
      title: "transferred",
    },
    {
      value: "ADJUST",
      title: "assigned",
    },
  ],
  applicantPositionOptions: [
    { value: "DIRECTOR", title: "Director of the proposed company/fund" },
    { value: "SHAREHOLDER", title: "Direct shareholder of the proposed company/fund" },
    { value: "INDIRECT_SHAREHOLDER", title: "Intermediary/ultimate shareholder of the proposed company/fund" },
    { value: "OTHER", title: "Other" },
  ],
  // quotation报价第三方费用备注选项
  thirdPartyFeeEnOptions: [
    { value: "Fees paid to ACRA" },
    { value: "Nominee director fee (1 person / 1 year)" },
    { value: "Other third party fee" },
    { value: "N/A" },
  ],
  // quotation报价其他费用备注选项
  otherFeeEnOptions: [{ value: "Deposit" }, { value: "N/A" }],
  // 基金类型
  fundTypes: [
    {
      value: "Non-umbrella VCC",
      title: "Non-umbrella VCC",
    },
    {
      value: "Umbrella VCC",
      title: "Umbrella VCC",
    },
    {
      value: "Sub-fund",
      title: "Sub-fund",
    },
    {
      value: "Others",
      title: "Others",
    },
  ],
  // client Code 状态
  clientCodeStatusList: [
    {
      //已提交
      title: "Submitted",
      value: 0,
    },
    {
      //复核成功
      title: "Review Passed",
      value: 1,
    },
    {
      //复核失败
      title: "Review Failed",
      value: 2,
    },
    {
      //禁用(客户丢了、不再用了)
      title: "Inactive",
      value: 3,
    },
  ],
  // client Code 是否需要佣金
  introducedByList: [
    {
      title: "Commission Required",
      value: 1,
    },
    {
      title: "No Commission",
      value: 0,
    },
  ],
  // engagement 公司类型列表
  engagementCompanyTypeList: [
    { title: "Company", value: "COMPANY" },
    { title: "Fund", value: "FUND" },
    { title: "Others", value: "OTHERS" },
  ],
  // engagement 状态列表
  engagementStatusList: [
    { title: "Open", value: "OPEN" },
    { title: "Closed", value: "CLOSE" },
    { title: "Reopen Submitted", value: "REOPEN" },
  ],
  // engagement control 类型以及对应描述列表
  engagementControlTypeAndDescriptionList: [
    {
      title: "AGM/EGM",
      description: "AGM",
    },
    {
      title: "Report Filing",
      description: "Annual Return",
    },
    {
      title: "Report Filing",
      description: "XBRL",
    },
    {
      title: "CIT filing",
      description: "ECI filing",
    },
    {
      title: "CIT filing",
      description: "C-S|C filing",
    },
    {
      title: "GST filing",
      description: "GST filing",
    },
    {
      title: "Other tax filing",
      description: "Other tax filing",
    },
    {
      title: "Secretary",
      description: "Basic secretary services",
    },
    {
      title: "Account",
      description: "Book-keeping services",
    },
    {
      title: "Account",
      description: "Unaudited financial statements",
    },
    {
      title: "Advisory",
      description: "Tax advisory",
    },
    // {
    //   title: "IIT",
    //   description: "Individual Income Tax",
    // },
    // {
    //   title: "Visa",
    //   description: "Visa",
    // },
    {
      title: "HR",
      description: "EP services",
    },
    {
      title: "Others",
      description: "Others",
    },
  ],
  // engagement control 类型列表
  engagementControlTypeList: [
    "AGM/EGM",
    "Report Filing",
    "CIT filing",
    "GST filing",
    "Other tax filing",
    "Secretary",
    "Account",
    "Advisory",
    // "IIT",
    // "Visa",
    "HR",
    "Others",
  ],
  // engagement control 关联服务类型列表
  engagementControlLinkedServiceTypeList: [
    { title: "Secretary", value: "SECRETARY" },
    { title: "Accounting", value: "ACCOUNTING" },
    { title: "Report", value: "REPORT" },
    { title: "Tax", value: "TAX" },
    { title: "Fund Admin", value: "FUND_ADMIN" },
    { title: "Treasury", value: "TREASURY" },
    { title: "Others", value: "OTHERS" },
  ],
  // engagement control 状态列表
  engagementControlStatusList: [
    { title: "Not started", value: "NOT_STARTED" },
    { title: "In progress", value: "IN_PROGRESS" },
    { title: "Completed", value: "COMPLETED" },
    { title: "N/A", value: "NONE" },
  ],
  // 月份列表
  monthOptions: [
    {
      title: "Jan",
      value: "01",
    },
    {
      title: "Feb",
      value: "02",
    },
    {
      title: "Mar",
      value: "03",
    },
    {
      title: "Apr",
      value: "04",
    },
    {
      title: "May",
      value: "05",
    },
    {
      title: "Jun",
      value: "06",
    },
    {
      title: "Jul",
      value: "07",
    },
    {
      title: "Aug",
      value: "08",
    },
    {
      title: "Sep",
      value: "09",
    },
    {
      title: "Oct",
      value: "10",
    },
    {
      title: "Nov",
      value: "11",
    },
    {
      title: "Dec",
      value: "12",
    },
  ],
  // engagement control 检查完成状态列表
  completedCheckOptions: [
    {
      title: "Yes",
      value: "YES",
    },
    {
      title: "No",
      value: "NO",
    },
    {
      title: "N/A",
      value: "NONE",
    },
  ],
  // 重启审核状态列表
  reopenStatusList: [
    {
      // 重启审核请求已提交
      title: "Reopen Submitted",
      value: 0,
    },
    {
      // 重启审核请求通过
      title: "Reopen Passed",
      value: 1,
    },
    {
      // 重启审核请求未通过
      title: "Reopen Failed",
      value: 2,
    },
  ],
  // Quotation(V)补款状态
  adjustmentStatusList: [
    {
      // 待处理
      title: "Submitted",
      value: "PENDING",
    },
    {
      // 驳回
      title: "Rejected",
      value: "REJECTED",
    },
    {
      // 通过
      title: "Passed",
      value: "PASSED",
    },
    {
      // 禁用
      title: "Forfeited",
      value: "FORFEITED",
    },
  ],
  // 后付款状态
  creditStatusList: [
    {
      // 待审核
      title: "Submitted",
      value: "PENDING",
    },
    {
      // 通过
      title: "Passed",
      value: "PASSED",
    },
    {
      // 驳回
      title: "Rejected",
      value: "REJECTED",
    },
  ],
  // 协议类型
  protocolTypeList: [
    {
      title: "Nominee Director Agreement",
      value: "NOMINEE_DIRECTOR_AGREEMENT",
    },
    {
      title: "Service Agreement (Corporate related)",
      value: "SERVICE_AGREEMENT",
    },
    {
      title: "Service Agreement (Fund related)",
      value: "ENGAGEMENT_LETTER",
    },
    {
      title: "EP Service Agreement",
      value: "EP_SERVICE_AGREEMENT",
    },
  ],
  // 发票类型
  invoiceTypeList: [
    { title: "Invoice", value: 1 },
    { title: "Credit Invoice", value: 2 },
  ],
  // 发票中的费用类型
  invoiceItemCategoryList: [
    { title: "Service Charge", value: 1 },
    { title: "Third Party Fee", value: 2 },
    { title: "Other Fee", value: 3 },
  ],
  // 汇率货币列表（SGD 为基准货币）
  exRateCurrencyExclusiveList: [
    { currency: "SGD", title: "Singapore Dollar", exchangeRateBasis: "1" },
    { currency: "EUR", title: "European Monetary Union Euro", exchangeRateBasis: "1" },
    { currency: "GBP", title: "United Kingdom Pound", exchangeRateBasis: "1" },
    { currency: "USD", title: "US Dollar", exchangeRateBasis: "1" },
    { currency: "AUD", title: "Australia Dollar", exchangeRateBasis: "100" },
    { currency: "CAD", title: "Canada Dollar", exchangeRateBasis: "100" },
    { currency: "CNY", title: "Chinese Yuan Renminbi", exchangeRateBasis: "100" },
    { currency: "HKD", title: "Hong Kong Dollar", exchangeRateBasis: "100" },
    { currency: "INR", title: "India Rupee", exchangeRateBasis: "100" },
    { currency: "IDR", title: "Indonesian Rupiah", exchangeRateBasis: "100" },
    { currency: "JPY", title: "Japan Yen", exchangeRateBasis: "100" },
    { currency: "KRW", title: "South Korea Won", exchangeRateBasis: "100" },
    { currency: "MYR", title: "Malaysia Ringgit", exchangeRateBasis: "100" },
    { currency: "TWD", title: "New Taiwan Dollar", exchangeRateBasis: "100" },
    { currency: "NZD", title: "New Zealand Dollar", exchangeRateBasis: "100" },
    { currency: "PHP", title: "Philippine Peso", exchangeRateBasis: "100" },
    { currency: "QAR", title: "Qatar Riyal", exchangeRateBasis: "100" },
    { currency: "SAR", title: "Saudi Riyal", exchangeRateBasis: "100" },
    { currency: "CHF", title: "Switzerland Franc", exchangeRateBasis: "100" },
    { currency: "THB", title: "Thailand Baht", exchangeRateBasis: "100" },
    { currency: "AED", title: "Utd.Arab.Emir.Dirham", exchangeRateBasis: "100" },
    { currency: "VND", title: "Vietnamese Dong", exchangeRateBasis: "100" },
  ],
};
